import React from 'react';
import styled from 'styled-components';
import { Flex, Icon, Text } from '@galilee/lilee';
import PropTypes from 'prop-types';

const LoadingFlex = styled(Flex)`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 301;
    background-color: rgba(0, 0, 0, 0.6);
    text-align: center;    
    color: white;
`;

const MessageLoading = ({ message }) => (
  <LoadingFlex>
    <Icon size="40px" color="white" name="Spinner" stepping />
    <Text>{message}</Text>
  </LoadingFlex>
);

MessageLoading.propTypes = {
  message: PropTypes.string.isRequired,
};

export default MessageLoading;
